import { HTTP } from "../axios";

export default {
  logout: ({ commit }) => {
    commit("clear_user_data");
  },
};
